<template>
  <transition name="backdrop">
    <div v-if="backdropShow" class="backdrop" @click="backdropClose"></div>
  </transition>
</template>

<script>
export default {
  name: 'my-backdrop',

  computed: {
    backdropShow() {
      return this.$store.state.header.isOffCanvasOpen;
    },
  },

  methods: {
    backdropClose() {
      this.$store.commit('closeOffCanvas');
      document.getElementsByTagName('body')[0].classList.remove('drawer-open');
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  background-color: #231f20;
  position: fixed;
  top: 64px;
  left: 0;
  width: 100%;
  height: calc(100% - 64px);
  z-index: 2;
  opacity: 0.5;
  transition: opacity 0.15s linear;

  &.backdrop-enter,
  &.backdrop-leave-to {
    opacity: 0;
  }
}
</style>
